export function isSafeRedirectPath(path: string): boolean {
  if (!path.startsWith('/')) {
    return false;
  }

  if (path.startsWith('//')) {
    return false;
  }

  if (path.includes('\\')) {
    return false;
  }

  const pathname = path.split(/[?#]/)[0] ?? path;

  if (pathname.includes(':')) {
    return false;
  }

  return true;
}

export function resolveSafeRedirectPath(
  redirect: unknown,
  fallback: string,
): string {
  if (typeof redirect !== 'string' || !isSafeRedirectPath(redirect)) {
    return fallback;
  }

  return redirect;
}
